import { createSlice } from "@reduxjs/toolkit";

export interface ReservationListState {
  order: string;
}

const initialState: ReservationListState = {
  order: "dsc",
};

const ReservationListSlice = createSlice({
  name: "ReservationListSlice",
  initialState,
  reducers: {
    updateOrder: (state, action) => {
      state.order = action.payload.order;
    },
  },
});

export const { updateOrder } = ReservationListSlice.actions;
export default ReservationListSlice.reducer;
